(function(a){a.fingerprint=function(){function b(){return[navigator.userAgent,[screen.height,screen.width,screen.colorDepth].join("x"),(new Date).getTimezoneOffset(),!!window.sessionStorage,!!window.localStorage,a.map(navigator.plugins,function(b){return[b.name,b.description,a.map(b,function(a){return[a.type,a.suffixes].join("~")}).join(",")].join("::")}).join(";")].join("###")}function c(){if(typeof window.md5=="function")return md5(b());throw"md5 unavailable, please get it from http://github.com/wbond/md5-js/"}return c()}})(jQuery);

define("browserfingerprint", ["jquery","md5"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.browserfingerprint;
    };
}(this)));

